'use client';

import { ClearButton, Icon } from '@vuddy/components';
import { jsonAssignInlineVars } from '@vuddy/utils';
import * as styles from './floatingButton.css';

interface IHomeFloatingButtonProps {
  isShow: boolean;
  offset?: {
    bottom?: number;
    right?: number;
  };
}

export const HomeFloatingButton = ({
  isShow,
  offset,
}: IHomeFloatingButtonProps) => {
  const styleVars: Record<string, string> = {
    [styles.display]: isShow ? 'block' : 'none',
  };

  if (offset?.bottom !== undefined) {
    styleVars[styles.bottomOffset] = `${offset.bottom}px`;
  }

  if (offset?.right !== undefined) {
    styleVars[styles.rightOffset] = `${offset.right}px`;
  }

  const onClickToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ClearButton
      className={styles.wrapper}
      style={jsonAssignInlineVars(styleVars)}
      onClick={onClickToTop}>
      <Icon name="OUTLINE_ARROW_UP" />
    </ClearButton>
  );
};
